import React, { useState, useRef } from 'react';
import { Page } from 'components/layout';
import { Flex } from 'components/ui';
import { Playlist } from '../Playlist';
import { Player } from 'components/Player';
import { useDropsContext } from '../Drops/DropsContext';
import capitalize from 'lodash/capitalize';

// See this issue.
// https://github.com/vitejs/vite/issues/2139
import F from 'react-request-fullscreen';
const FullScreen = (F as any).default ? (F as any).default : F;

const HomePage: React.FC<{}> = () => {
  const { selectedDrop } = useDropsContext();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const fullScreenRef: any = useRef();

  const onFullScreenChange = () => {
    setIsFullScreen(isFullScreen => !isFullScreen);
  };

  const toggleFullScreen = () => {
    fullScreenRef?.current?.fullScreen();
  };

  return (
    <FullScreen
      ref={fullScreenRef}
      onFullScreenChange={onFullScreenChange}
      onFullScreenError={error => console.error(error)}
    >
      <Page
        title={capitalize(selectedDrop)}
        p="0"
        fixedFooter={false}
        showHeader={!isFullScreen}
        showFooter={!isFullScreen}
      >
        <Flex flexWrap={['wrap', 'wrap', 'nowrap']} justifyCenter>
          <Flex width={['100%', '100%', '50%']} order={[1, 1, 2]} px={[0, 0, 0, 4]}>
            <Player isFullScreen={isFullScreen} toggleFullScreen={toggleFullScreen} />
          </Flex>

          {!isFullScreen && (
            <Flex
              width={['100%', '100%', '50%']}
              order={[2, 2, 1]}
              py={2}
              mt={[0, 0, 0]}
              bg="background"
            >
              <Playlist
                height={[
                  'calc(100vh - 300px)',
                  'calc(100vh - 64px)',
                  'calc(100vh - 64px)',
                  'calc(100vh - 64px)',
                ]}
              />
            </Flex>
          )}
        </Flex>
      </Page>
    </FullScreen>
  );
};

export default HomePage;
